export const fillingDates = (yearParams = 2017, monthParams?: string) => {
  const month = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  let year = yearParams;
  let recentYear: number = new Date().getFullYear();

  let dateArray: { label: string; value: string }[] = [];
  const gapInYears = recentYear - year + 1;
  dateArray.push({ label: "None", value: "" });
  let yearArray: number[] = [];
  let count = 0;
  for (let i = 0; i < gapInYears; i++) {
    yearArray.push(year);
    year++;
    count++;
    if (count === gapInYears) {
      break;
    }
  }
  let startingMonth: string[] = [];
  if (monthParams) {
    let index = month.indexOf(monthParams);
    for (let i = index; i < month?.length; i++) {
      startingMonth.push(month[i]);
    }
  }

  yearArray?.map((item: number) => {
    let mappingMonth =
      item === yearParams && monthParams ? startingMonth : month;
    mappingMonth.map((mitem: string, i: number) => {
      if (i > new Date().getMonth() && item == recentYear) {
        return;
      }
      let obj: any = {};

      obj.label = mitem + "-" + item.toString().split("").slice(2).join("");
      obj.value = mitem + "-" + item.toString().split("").slice(2).join("");
      dateArray.push(obj);
    });
  });
  return dateArray?.reverse();
};

export function finacialYearMonth(
  financialStartYear: string,
  monthParams: string,
  financialEndYear?: number
) {
  const month = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  let dateArray: { label: string; value: string }[] = [];
  for (let i = month.indexOf(monthParams); i < month.length; i++) {
    let obj: any = {};

    obj.label = month[i] + "-" + financialStartYear;
    obj.value = month[i] + "-" + financialStartYear;
    dateArray.push(obj);
  }
  for (let i = 0; i < month.indexOf(monthParams); i++) {
    let obj: any = {};

    obj.label = month[i] + "-" + financialEndYear;
    obj.value = month[i] + "-" + financialEndYear;
    dateArray.push(obj);
  }
  return dateArray;
}
export function reclaimFinacialYearMonth(
  financialStartYear: string,
  monthParams: string,
  financialEndYear?: number
) {
  const month = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  let dateArray: { label: string; value: string }[] = [];
  for (let i = month.indexOf(monthParams) + 1; i < month.length; i++) {
    let obj: any = {};

    obj.label = month[i] + "-" + financialStartYear;
    obj.value = month[i] + "-" + financialStartYear;
    dateArray.push(obj);
  }
  dateArray.push({ label: "None", value: "" });

  for (let i = 0; i < month.indexOf(monthParams); i++) {
    let obj: any = {};

    obj.label = month[i] + "-" + financialEndYear;
    obj.value = month[i] + "-" + financialEndYear;
    dateArray.push(obj);
  }
  return dateArray;
}

export function finacialYear(year: number) {
  let finacialData = [];
  let recentYear: number = new Date().getFullYear();
  let month: number = new Date().getMonth();
  let diff = recentYear - year;

  for (let i = 0; i < (month >= 3 ? diff + 1 : diff); i++) {
    let obj: any = {};

    obj.label =
      year + i + "-" + (+year.toString().split("").slice(2).join("") + (i + 1));
    obj.value =
      year + i + "-" + (+year.toString().split("").slice(2).join("") + (i + 1));

    finacialData.push(obj);
  }

  return finacialData;
}

export const getMonths = () => {
  let fullMonths = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  let monthsOptions = [];
  for (let i = 0; i < fullMonths.length; i++) {
    let obj: any = {};
    obj.label = fullMonths[i];
    obj.value = i + 1;

    monthsOptions.push(obj);
  }

  return monthsOptions;
};

export const getFullMonthsAndYear = (data: string) => {
  const month = data?.split("-")[0];
  const year = data?.split("-")[1];
  switch (month) {
    case "Jan":
      return `January-20${year}`;
    case "Feb":
      return `February-20${year}`;
    case "Mar":
      return `March-20${year}`;
    case "Apr":
      return `April-20${year}`;
    case "May":
      return `May-20${year}`;
    case "Jun":
      return `June-20${year}`;
    case "Jul":
      return `July-20${year}`;
    case "Aug":
      return `August-20${year}`;
    case "Sep":
      return `September-20${year}`;
    case "Oct":
      return `October-20${year}`;
    case "Nov":
      return `November-20${year}`;
    case "Dec":
      return `December-20${year}`;
    default:
      return `April-20${year}`;
  }
};
